import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocaleProvider } from './components/LocaleProvider';
import { Home } from './pages/Home';
import { CategoryPage } from './pages/CategoryPage';
import { ContactPage } from './pages/ContactPage';
import { StandardPage } from './pages/StandardPage';
import { WholesalePage } from './pages/WholesalePage';
export function App() {
  return <LocaleProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/categories" element={<CategoryPage data-id="element-6" />} data-id="element-5" />
          <Route path="/brands" element={<StandardPage data-id="element-8" />} data-id="element-7" />
          <Route path="/gallery" element={<StandardPage data-id="element-10" />} data-id="element-9" />
          <Route path="/news" element={<StandardPage data-id="element-12" />} data-id="element-11" />
          <Route path="/about" element={<StandardPage data-id="element-14" />} data-id="element-13" />
          <Route path="/wholesale" element={<WholesalePage data-id="element-16" />} data-id="element-15" />
          <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
        </Routes>
      </BrowserRouter>
    </LocaleProvider>;
}